<template>
  <div class="env-monitoring">
    <div class="page-main">
      <iframe
        id="iframeBox"
        name="iframeBox"
        seamless
        scrolling="no"
        :src="iframeUrl"
      ></iframe>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      iframeUrl: ''
    }
  },
  mounted() {
    let url =process.env.VUE_APP_BASE_API
    if(this.$i18n.locale==='zh-CN'){
      this.iframeUrl='../../../static/envMonitoring/data.html?token='+this.$store.state.user.token
    }else{
      this.iframeUrl='../../../static/envMonitoring/data_en.html?token='+this.$store.state.user.token
    }
  }
}
</script>
<style lang="less" scoped>
.env-monitoring {
	position: relative;
	width: 100%;
	height:100%;
	background:#191923;
  .page-main{
    position: absolute;
    top:10px;
    left:0;
    right:0;
    bottom:0;
    overflow: hidden;
  }
}
</style>